import { useNavigate } from "react-router-dom"

import { useAuthStore } from "../store/auth-store"

export function useLogout() {
  const navigate = useNavigate()
  const signOut = useAuthStore((state) => state.signOut)

  function handleLogout() {
    signOut()
    navigate("/login", { replace: true })
  }

  return { handleLogout }
}